<div class="modal-content">
    <div class="modal-header">
      <h3 class="modal-title"><strong>DESISTIR DA FICHA</strong></h3>
    </div>
    <div class="modal-body">
      <h4 class="text-center">Você esta prestes a efetuar a desistência do negócio, esta ação não pode ser desfeita.</h4>
      <h4 class="text-center">Informe o motivo da desistência para completar a ação.</h4>
    </div>

    <div class="modal-footer">
        <div class="text-center">
          <button class="btn btn-border-orange" (click)="desistir()">Cliente Desistiu</button>
          <br>
          <button class="btn btn-border-orange mt15" (click)="outraFinanceira()">Fechou com outra financeira</button>
          <br>
          <button class="btn btn-full-orange mt15" (click)="fechar()">Cancelar</button>
        </div>
    </div>
  </div>
